import { EventDispatcher } from "../event-dispatcher.js";
export const insoleParameterChanged = new EventDispatcher();
export const insoleTemplateChanged = new EventDispatcher();
//# sourceMappingURL=insole-parameter-change.event.js.map